import apiConfig from '../../config/api_config';

export const doctorApi = {
    getDoctors: (param) => apiConfig.get('/doctors/', param),
    newDoctor: (doctorData) => apiConfig.post('/doctors/', doctorData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                  },
                }),
    getDoctorApplicationStatus: () => apiConfig.get('/doctors/application-status/'),
    getDoctorById: (doctorId) => apiConfig.get(`/doctors/${doctorId}/`),
    updateDoctor: (doctorId, doctorData) => apiConfig.put(`/doctors/${doctorId}/`, doctorData),
    verifyDoctor: (doctorId) => apiConfig.post(`/doctors/${doctorId}/verify/`),
    getDoctorCases: (doctorId) => apiConfig.get(`/cases/`, { params: { doctor_id: doctorId } }),
};